import { Outlet } from 'react-router-dom';
import { CreativeWorkbenchProvider } from '@/pages/creative/CreativeWorkbenchContext';

/**
 * Outer wrapper for the new `/performance/creative/*` route subtree.
 *
 * Provides the Creative Workbench context (clientUid, persona, date range)
 * that the legacy PerformanceView components require. Child routes are
 * mounted explicitly in `router.tsx` to side-step the `endsWith` URL
 * sniffing in PerformanceView/index.tsx (which only matched the legacy
 * `/creative/performance/*` prefix).
 */
export function CreativePerformanceLayout() {
  return (
    <CreativeWorkbenchProvider>
      <Outlet />
    </CreativeWorkbenchProvider>
  );
}

export default CreativePerformanceLayout;
